import React from "react";
import "./UiHeader.css";
import FullScreenButton from "./FullScreenButton";

const UiHeader: React.FC = () => {
  return (
    <div className="configurator-header">
      {/* <div className="configurator-title">
        <h1>Ontwerp uw Douglas overkapping</h1>
      </div> */}
    </div>
  );
};

export default UiHeader;
